<template>
  <Page title="Laporan" :sidebar="true">
    <div style="background:white;  overflow-x: hidden; overflow-y: auto;">
      <div class="rowlnk">
        <v-btn
          small
          dense
          text
          color="primary"
          @click="Generate($event, { sp: 'SPD_RptJmlPerjalananDinas' })"
        >
          Jml Perjalanan Dinas
        </v-btn>
      </div>
    </div>
    <div>
      <ReportParams
        v-show="showParams"
        :options="reportOptions"
        :reportParams.sync="reportParams"
        :generatedUrl.sync="reportUrl"
      />
      <ReportViewer
        :url="reportUrl"
        :options="reportParams"
        :show.sync="showReport"
      />
    </div>
  </Page>
</template>
<script>
import { mapActions } from 'vuex'
import ReportParams from '../../components/Report/Params'
import ReportViewer from '../../components/ReportViewer'

export default {
  components: {
    ReportParams,
    ReportViewer,
  },
  data: () => ({
    reportOptions: null,
    reportUrl: 'about:blank',
    showReport: false,
    showParams: false,
    reportParams: {},
  }),
  watch: {
    // reportUrl(val) {
    //   if (val) this.showReport = true
    // },
    reportParams(val) {
      if (val) this.showReport = true
    },
  },
  methods: {
    ...mapActions(['setPageFocused']),
    Generate(evt, opts) {
      this.setPageFocused(true)
      this.showReport = false
      this.showParams = true
      opts.rptname = evt.target.innerText
      this.reportOptions = opts
    },
  },
}
</script>
<style lang="scss">
.rowlnk {
  border-bottom: 1px solid #ddd;
  padding: 5px 0;
}
.page-content.has-sidebar > div:nth-child(2) {
  background: rgba(255, 255, 255, 1);
}
</style>
